import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { LogIn } from 'lucide-react';
import Button from './Button';

function SessionExpiredModal({ isOpen, message, onRelogin }) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const { body } = document;
    const previousOverflow = body.style.overflow;

    body.style.overflow = 'hidden';

    return () => {
      body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[80] flex items-center justify-center overflow-y-auto bg-[rgba(17,17,17,0.26)] px-4 py-6 backdrop-blur-[4px]">
      <div className="w-full max-w-[430px] cursor-default select-none overflow-hidden rounded-[30px] border border-[#e9e0d8] bg-[linear-gradient(180deg,#fdfcfb_0%,#faf6f1_100%)] shadow-[0_24px_60px_rgba(17,17,17,0.14)]">
        <div className="border-b border-[#ebe3db] px-5 py-5 sm:px-6">
          <div className="flex items-start gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[20px] border border-[#e7ddd3] bg-[#f7f4ef] text-[#6f5644]">
              <LogIn className="h-6 w-6" aria-hidden="true" />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="m-0 text-[1.18rem] font-semibold tracking-[-0.02em] text-[#111111] sm:text-[1.28rem]">
                Session expired
              </h3>
              <p className="mt-2 text-sm leading-6 text-[#7f736b]">
                {message || 'Your session expired. Please login again.'}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end px-5 py-4 sm:px-6">
          <Button
            className="w-full justify-center rounded-[16px] border-[#6f5644] bg-[#6f5644] px-4.5 py-2.5 text-[14px] font-semibold text-white shadow-[0_14px_28px_rgba(111,86,68,0.16)] hover:translate-y-[-1px] hover:bg-[#5f4a3b] sm:w-auto"
            type="button"
            onClick={onRelogin}
          >
            Relogin
          </Button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default SessionExpiredModal;
